module.exports = __webpack_public_path__ + "img/PORT01.85374343.jpg";